import Color from "../../layouts/Color";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Grid, List, ListItem, Typography } from "@mui/material";
import { ListQuestion } from "./ListQuestion";
import clsx from 'clsx'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import FontSize from "../../layouts/FontSize";

const box = {
    display: 'flex',
    overflow: 'hidden'
}

const container = {
    mt: 5,
    mb: 7,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}

const title = {
    mb: 6,
    color: Color.Dangerous
}

const list = {
    mb: 2,
    border: '1px solid #e0e5ef',
    boxShadow: '0 1px 4px 0 rgb(0 0 0 / 6%)',
    textAlign: 'left'
}

export default function FrequentQuestion() {
    const classes = useStyles();
    const [selected, setSelected] = useState(0);
    const [expanded, setExpanded] = useState(null);

    return (
        <Box
            component="section"
            sx={box}
        >
            <Container
                sx={container}
            >
                <Typography variant="h4" sx={title}>Frequently asked questions</Typography>
                <Container
                    maxWidth="lg"
                >
                    <Box>
                        <Grid container spacing={2}>
                            <Grid item xs={3}>
                                <List>
                                    {ListQuestion.map((p, index) => {
                                        return (
                                            <ListItem
                                                key={index}
                                                className={clsx(classes.item, { [classes.itemSelected]: selected === index })}
                                                onClick={() => {
                                                    setSelected(index)
                                                    setExpanded(null);
                                                }}
                                            >
                                                <Typography variant="h6" color="inherit">{`${p.number}. ${p.topic}`}</Typography>
                                            </ListItem>
                                        )
                                    })}
                                </List>
                            </Grid>
                            <Grid item xs={9}>
                                <Box>
                                    {ListQuestion[selected].questions.map((p, index) => {
                                        return (
                                            <Accordion
                                                key={index}
                                                expanded={expanded === index}
                                                onChange={() => setExpanded(index)}
                                                sx={list}
                                            >
                                                <AccordionSummary
                                                    expandIcon={
                                                        expanded === index ?
                                                            <RemoveCircleIcon sx={{ color: expanded === index ? Color.Active : Color.Normal }} /> :
                                                            <AddCircleIcon sx={{ color: expanded === index ? Color.Active : Color.Normal  }} />
                                                    }
                                                    sx={{ color: expanded === index ? Color.Active : Color.Normal }}
                                                >
                                                    <Typography variant="h6" color="inherit">{`${index}. ${p.question}`}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Typography variant="body1">{p.answer}</Typography>
                                                    {p.steps !== undefined &&
                                                        <List>
                                                            {p.steps.map((step, ii) => {
                                                                return (
                                                                    <ListItem key={ii}>
                                                                        {`Step ${ii}: ${step}`}
                                                                    </ListItem>
                                                                )
                                                            })}
                                                        </List>
                                                    }
                                                </AccordionDetails>
                                            </Accordion>
                                        )
                                    })}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
            </Container>
        </Box>
    )
}

const useStyles = makeStyles({
    item: {
        '&:hover': {
            color: Color.Active,
            borderRight: '2px solid'
        },
        color: Color.Normal,
        cursor: 'pointer',
        marginBottom: '10px',
        paddingTop: '4px',
        paddingBottom: '4px',
        fontFamily: "'Asap', normal",
        fontSize: FontSize.Medium
    },
    itemSelected: {
        color: Color.Active,
        borderRight: '2px solid'
    }
});
